import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { BasicError } from '../../models/error/error';
import { NaviService } from '../../services/navi.service';
import { MessageService } from '../../services/message.service';

import { User } from '../../models/user';
import { Alarm } from '../../models/alarm';
import { Thread } from '../../models/thread';
import { AuthenticationService } from '../../services/authentication.service';
import { AlarmService } from '../../services/alarm.service';
declare var Notification: any;

@Component({
  selector: 'app-navi-top',
  templateUrl: './navi-top.component.html',
  styleUrls: ['./navi-top.component.css']
})
export class NaviTopComponent implements OnInit {

  public name: String = '...';
  public img: String = 'assets/img/user.png';
  public alarmLength = 0;
  public alarms = [];
  public warnings = [];
  public allUsers = {};
  public users = [];
  public amounts = {};
  public threads = [];
  public unreadThreads = [];
  public amountUnread = 0;
  public allMessages = 0;
  public oldAmount = 0;
  public refreshMessageTimer = null;
  public messageNavigationUrl = 'messages/';

  constructor(private profileService: ProfileService, private auth: AuthenticationService, private naviService: NaviService,
    private alarm: AlarmService, private messages: MessageService) {
    this.profileService.getMyProfile().subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      } else if (data instanceof User) {
        this.name = data.getFirstName() + ' ' + data.getLastName();

        if (data.getPicture() !== undefined && data.getPicture() !== null) {
          this.img = data.getPicture();
        }
      }
    });

    this.profileService.getMyRoles().subscribe(roles => {
      if (roles instanceof BasicError) {
        // No roles
        console.log('Could not get roles of current user');
      } else if (roles.length > 0) {
        this.alarm.observe().subscribe(json => {
          const rr = this.alarm.getCurrentAlarms();
          this.alarms = rr.alarms;
          this.warnings = rr.warnings;

          this.allUsers = {};
          this.users = [];

          for (const a of this.alarms) {
            if (a instanceof Alarm) {
              if (this.allUsers[a.getUser().getID().toString()] === undefined) {
                this.allUsers[a.getUser().getID().toString()] = a.getUser();
                this.users.push(a.getUser());
                this.amounts[a.getUser().getID().toString()] = 1;
              } else {
                this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
              }
            }
          }

          for (const a of this.warnings) {
            if (a instanceof Alarm) {
              if (this.allUsers[a.getUser().getID().toString()] === undefined) {
                this.allUsers[a.getUser().getID().toString()] = a.getUser();
                this.users.push(a.getUser());
                this.amounts[a.getUser().getID().toString()] = 1;
              } else {
                this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
              }
            }
          }
        });

        const rr = this.alarm.getCurrentAlarms();
        this.alarms = rr.alarms;
        this.warnings = rr.warnings;

        this.allUsers = {};
        this.users = [];

        for (const a of this.alarms) {
          if (a instanceof Alarm) {
            if (this.allUsers[a.getUser().getID().toString()] === undefined) {
              this.allUsers[a.getUser().getID().toString()] = a.getUser();
              this.users.push(a.getUser());
              this.amounts[a.getUser().getID().toString()] = 1;
            } else {
              this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
            }
          }
        }

        for (const a of this.warnings) {
          if (a instanceof Alarm) {
            if (this.allUsers[a.getUser().getID().toString()] === undefined) {
              this.allUsers[a.getUser().getID().toString()] = a.getUser();
              this.users.push(a.getUser());
              this.amounts[a.getUser().getID().toString()] = 1;
            } else {
              this.amounts[a.getUser().getID().toString()] = this.amounts[a.getUser().getID().toString()] + 1;
            }
          }
        }
      }
    });


  }

  ngOnInit() {
    if (this.messages.serviceStorage['oldAmount'] === undefined) {
      this.messages.serviceStorage['oldAmount'] = 0;
    }

    this.updateMessages();
    this.messages.registerReadUpdate().subscribe(json => {
      this.updateMessages();
    });

  }

  public logout(): void {
    this.auth.logout();
  }

  /**
   * Navigate to follow string
   * @param name string to navigate to
   */
  public navigate(name: String): void {
    this.naviService.setCurrentPage(name);
  }

  /**
   * Function to get all threads
   */
  public updateMessages() {
    if (this.refreshMessageTimer !== null) {
      clearTimeout(this.refreshMessageTimer);
    }

    this.messages.getAllMessages().subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Could not read all messages');
        return;
      }
      this.amountUnread = 0;
      this.allMessages = 0;
      this.unreadThreads = [];
      this.threads = json;

      for (const thread of this.threads) {
        if (thread instanceof Thread) {
          if (thread.getAmountUnreadMessages() > 0) {
            this.amountUnread = this.amountUnread + thread.getAmountUnreadMessages().valueOf();
            this.unreadThreads.push(thread);
          }
          this.allMessages = this.allMessages + thread.getAmountMessages().valueOf();
        }
      }

      const self = this;
      if (this.amountUnread > this.messages.serviceStorage['oldAmount']) {
        if (Notification.permission !== 'granted') {
          Notification.requestPermission().then(function (result) {
            self.showNotification(self.amountUnread);
          });
        } else {
          this.showNotification(this.amountUnread);
        }
      }

      this.messages.serviceStorage['oldAmount'] = this.amountUnread;

      this.refreshMessageTimer = setTimeout(function () {
        self.updateMessages();
      }, 60000);
    });
  }

  /**
   * Navigate to message
   */
  public navigateToMessage(threadId) {
    const url = this.messageNavigationUrl + threadId;
    this.naviService.navigateToUrl(url, 'messages');
  }

  /**
   * Function to show Notifications
   * @param amount
   */
  public showNotification(amount) {
    const notification = new Notification('Sie haben noch ' + amount + ' ungelesene Nachrichten.');
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/navi-top/navi-top.component.ts